import React, { useState } from "react";
import axios from "axios";
import { useContext } from "react";
import RegistrationContext from "../contexts/RegistrationContext";
import { base_url } from "../config";
import RegistrationNotice from "../components/RegistrationNotice/RegistrationNotice";

function Signin() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    code: "",
  });
  const [currentStep, setCurrentStep] = useState(1); // Step 1: Create Account, Step 2: Enter Code, Step 3: Success
  const [error, setError] = useState("");
  const { setAuthenticated, setReload, reload, setScreen } = useContext(RegistrationContext);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleCreateAccount = async (event) => {
    event.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (formData.password.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }
    try {
      await axios.post(`${base_url}/api/register`, {
        email: formData.email,
        password: formData.password,
      });
      setError("");
      setCurrentStep(2); // Move to Step 2
    } catch (error) {
      setError("Registration failed. " + error.response?.data?.message || "Unknown error");
    }
  };

  const handleVerifyCode = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${base_url}/api/register-code`, {
        email: formData.email,
        code: formData.code,
      });
      setAuthenticated(true);
      localStorage.setItem("token", response.data.access_token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.access_token}`;
      setReload(reload + 1);
      setCurrentStep(3); // Move to Step 3
    } catch (error) {
      setError("Verification failed. " + error.response?.data?.message || "Unknown error");
    }
  };

  return (
    <main className="flex-1">
      <div className="container mx-auto px-4">
        <div className="text-center py-8">
          <h2 className="text-2xl font-medium text-gray-800">Welcome to the IJCAI-ECAI 2026 registration system</h2>
        </div>

        <div className="max-w-3xl mx-auto py-8">
          <div className="bg-white rounded-xl shadow-lg p-8">
            {currentStep === 1 && (
              <form onSubmit={handleCreateAccount} className="flex flex-col gap-6">
                <h2 className="text-2xl font-bold text-gray-800">Sign Up to Register for IJCAI-ECAI 2026</h2>
                <div className="flex flex-col md:flex-row items-center gap-4">
                  <label
                    htmlFor="email"
                    className="md:w-40 text-right md:text-left font-medium text-gray-700"
                  >
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="name@company.com"
                  />
                </div>

                <div className="flex flex-col md:flex-row items-center gap-4">
                  <label
                    htmlFor="password"
                    className="md:w-40 text-right md:text-left font-medium text-gray-700"
                  >
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="••••••••"
                  />
                </div>

                <div className="flex flex-col md:flex-row items-center gap-4">
                  <label
                    htmlFor="confirmPassword"
                    className="md:w-40 text-right md:text-left font-medium text-gray-700"
                  >
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    className="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="••••••••"
                  />
                </div>
                {error && <p className="text-red-600">{error}</p>}


                <div className="flex flex-wrap items-center gap-4 mt-4">

                  <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors" type="submit">
                    Create Account
                  </button>
                  <div className="text-sm text-gray-600">
                    Already have an account?
                    &nbsp;
                    <button type="button" onClick={() => setScreen("login")} className="text-sm text-blue-600 hover:text-blue-800 hover:underline transition-colors">
                      Log in here
                    </button>
                    &nbsp;

                  </div>
                </div>
              </form>
            )}

            {currentStep === 2 && (
              <form onSubmit={handleVerifyCode} className="flex flex-col gap-6 ">
                <h2 className="text-2xl font-bold text-gray-800">Enter Verification Code</h2>
                <p className="text-gray-600">
                  We've sent a 6-digit verification code to your email: <strong>{formData.email}</strong>.
                </p>
                <div className="flex flex-col gap-4">
                  <label htmlFor="code" className="font-medium text-gray-700">
                    Verification Code
                  </label>
                  <input
                    type="text"
                    id="code"
                    name="code"
                    value={formData.code}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your code"
                  />
                </div>
                {error && <p className="text-red-600">{error}</p>}


                <div className="flex flex-wrap items-center gap-4">

                  <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors" type="submit">
                    Verify Code
                  </button>

                  <button type="button" onClick={() => setCurrentStep(1)} className="text-sm text-blue-600 hover:text-blue-800 hover:underline transition-colors">
                    Return to login
                  </button>
                </div>
              </form>
            )}

            {currentStep === 3 && (
              <div className="text-center">
                <h2 className="text-2xl font-bold text-gray-800">Success</h2>
                <p className="text-gray-600">
                  Your account has been successfully created! You can now access the application.
                </p>
                <button
                  onClick={() => setScreen("dashboard")}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors mt-4"
                >
                  Start Using App
                </button>

              </div>
            )}

          
          </div>
        </div>
        <RegistrationNotice />
      </div>
    </main>
  );
}

export default Signin;